import { ProductsPage } from 'pages/products';

export const ProductsView = () => {
  return <ProductsPage />;
};
